module.exports = __webpack_public_path__ + "img/info.3bcc4825.png";